import { ChartViewUI } from './pc/chart-view-ui.js';

export function chartEffects() {
  if (customElements.get('affine-data-view-chart')) {
    return;
  }
  customElements.define('affine-data-view-chart', ChartViewUI);
}
